export default __webpack_public_path__ + "static/media/video-mute.c35c9b5a.svg";